import IconRenderer from "@/libs/contentful/helper/IconRenderer";
import React, {useContext} from "react";
import {MegaMenuContext} from "@/components/Layout/Header/Navigation/MainNavProvider";
import useWindowDimensions from "@/libs/contentful/helper/useWindowDimension";
import clsx from "clsx";
import {useTranslations} from "next-intl";

interface Props {
    className?: string
    menuId: string
    menuName: string
    children?: React.ReactNode
}
export default function NavFocusButton({className, menuId, menuName, children}: Props) {
    const {isMegaMenuOpen, toggleMegaMenu } = useContext(MegaMenuContext);
    const { width } = useWindowDimensions();
    const t = useTranslations();
    return (
        <span className={clsx(className, "relative group/hover flex justify-between items-center p-mobile md:p-[0]")}>
            {children}
            <button className="md:absolute md:right-[0] md:top-[16] group/button pointer-events-none"
                    aria-label={t('Defaults.open') + ' ' + menuName + ' ' + t('MainMenu.menu')}
                    onClick={() => toggleMegaMenu(!isMegaMenuOpen)}
                    aria-controls={menuId}
                    aria-expanded={isMegaMenuOpen}
                    aria-haspopup="dialog"
                    type="button">
                <IconRenderer icon="icon-chevron-down"
                              className={"md:opacity-0 md:group-focus/button:opacity-100 w-[24px] brand-transition " + (width !== undefined && width < 834 && isMegaMenuOpen ? 'rotate-180' : '')}/>
            </button>
        </span>
    )
}